import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-transcription',
  templateUrl: './skeleton-transcription.component.html',
  styleUrls: ['./skeleton-transcription.component.scss']
})
export class SkeletonTranscriptionComponent {

  @Input() loadingSkeleton = false;

}
